var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    transform: "rotate(90 23 23)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7954 23.9083C30.0682 23.6224 30.0682 23.1589 29.7954 22.873L25.3483 18.2144C25.0753 17.9285 24.6328 17.9285 24.36 18.2144C24.0871 18.5003 24.0871 18.9638 24.36 19.2497L28.313 23.3906L24.36 27.5316C24.0871 27.8175 24.0871 28.281 24.36 28.5668C24.6328 28.8527 25.0753 28.8527 25.3483 28.5668L29.7954 23.9083ZM16 23.3906C16 23.7949 16.3277 24.1226 16.732 24.1226H29.3012V22.6586H16.732C16.3277 22.6586 16 22.9863 16 23.3906Z",
    fill: "#252730"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRounded);
export default __webpack_public_path__ + "static/media/ArrowRightRounded.bafdb3c4b4a9bbceafd47a9828c8bdc4.svg";
export { ForwardRef as ReactComponent };